import { initColorMode } from "./theme/colorMode"; // TODO: activate Darkmode

import changeEventForInput from "./helper/autofill-events";
import animateContentOnScroll from "./helper/animate-content-on-scroll";

import { scrollToID } from "./helper/helper";
import {
  initToggleDropdown,
  disableEmptyNavLinks,
  stickyNavigation,
} from "./partials/mb-navigation";
import { initNavIcon } from "./partials/mb-nav-icon";
import { initMbModal } from "./partials/mb-modal";
import { configLibraries } from "./theme/configLibraries";
import { linkWrapperClickHandler, initWatchHover } from "./theme/clickHandler";
import { initReadmore, updateReadMore } from "./partials/mb-readmore";
// import { mbYoutubeBorlabsGate } from "./partials/mb-youtube-borlabs-gate";

import { printDeveloperMessageToConsole } from "./helper/mbagentur";

/**
 * Init JS Helper
 */
changeEventForInput();

(function () {
  function init() {
    // // Get styling informations from css property values
    // const style = getComputedStyle(document.body);
    // const max_mainwidth = style.getPropertyValue("--maxMainWidth");

    // // TODO: activate Darkmode
    initColorMode();

    initNavIcon();
    initToggleDropdown();
    disableEmptyNavLinks();
    stickyNavigation();
    configLibraries();
    linkWrapperClickHandler();
    initWatchHover();
    animateContentOnScroll();
    initMbModal();
    initReadmore();
    // mbYoutubeBorlabsGate();

    printDeveloperMessageToConsole();
  }

  init();

  // On document ready
  docReady(function (context) {});
})();

/**
 * Remove page loader
 */
jQuery(window).on("load", function () {
  jQuery(".mb-loader-wrapper").fadeOut("slow", function () {
    jQuery(this).remove();
    document.body.setAttribute("aria-live", "assertive");
  });
});

/**
 * Smooth Anker scrolling
 */
jQuery('a[href*="#"]').on("click", function (e) {
  const target = this.hash;
  console.log("Hash", target);
  if (scrollToID(target, -50)) {
    e.preventDefault();
  }
});

/**
 * Document resize listener
 */
window.addEventListener("resize", (event) => {
  updateReadMore();
});

/**
 * Scroll top button
 */
let topbtn = document.getElementById("topbutton");

if (topbtn) {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 300 && topbtn) {
      topbtn.classList.add("show");
    } else if (topbtn) {
      topbtn.classList.remove("show");
    }
  });

  topbtn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
}
